import React from 'react';
import styler from 'react-styling';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import { OverlayTrigger, Popover, FormGroup, FormControl, Button } from 'react-bootstrap/lib';

import { getLocalDateFormat } from '../../libs/Time';

const style = styler `
  Title
    font-size: 20px
    color: 333
  
  Form
    margin-top: 10px

  Date
    background-color: #FFF
    border: 1px solid #FFF
    border-radius: 0
    box-shadow: none
    width: 250px
    float: left
    height: 40px
  
  Button
    position: relative
    left: -40px
    height: 40px
`;

type Props = {
  startDate: any,
  endDate: any,
  handleSelectDateRange: Function,
  schedulerDateMax: Object,
  schedulerDateMin: Object,
  languagedata: Object,
};

const dateFormat = getLocalDateFormat();

const ranges = {
  Today: {
    startDate: now => now,
    endDate: now => now,
  },
  Tomorrow: {
    startDate: now => now.add(1, 'days'),
    endDate: now => now.add(1, 'days'),
  },
  'Next 7 Days': {
    startDate: now => now,
    endDate: now => now.add(6, 'days'),
  },
};

const RangeDate = (props: Props) => {
  const datepicker = (
    <Popover className="scheduler-datepicker" id="scheduler-date-range-picker" title="Select a date range">
      <DateRange
        startDate={props.startDate}
        endDate={props.endDate}
        onChange={props.handleSelectDateRange}
        maxDate={props.schedulerDateMax}
        minDate={props.schedulerDateMin}
        calendars={1} // number of calendars to display
        twoStepChange={true}
        firstDayOfWeek={1}
        ranges={ranges}
        theme={{
          Calendar: { paddingTop: 5, paddingLeft: 0, width: 230 },
          PredefinedRanges: { marginTop: 10 },
          PredefinedRangesItemActive: { color: '#EF3232' },
        }}
      />
    </Popover>
    );

  return (
    <div>
      <div>
        <span style={style.Title}>{props.languagedata.date_range}</span>
      </div>
      <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={datepicker}>
        <FormGroup style={style.Form}>
          <FormControl
            inputRef="selectedDateRange"
            style={style.Date}
            className="pick-a-date"
            value={`${moment(props.startDate).format(dateFormat)} - ${moment(props.endDate).format(dateFormat)}`}
            placeholder="Datepicker"
            type="text"
            readOnly
          />
          <Button bsStyle="link" style={style.Button}>
            <i className="fa fa-calendar-o" />
          </Button>
        </FormGroup>
      </OverlayTrigger>
    </div>
  );
};

export default RangeDate;



// WEBPACK FOOTER //
// ./src/js/Components/Elements/RangeDate.js